// extracted by mini-css-extract-plugin
export var closeButton = "_ga-2";
export var closeButtonIcon = "_ga-3";
export var lightboxContent = "_ga-1";
export var lightboxOverlay = "_ga-0";